import { render, staticRenderFns } from "./FormLiquidation.vue?vue&type=template&id=0c3eb0a7"
import script from "./FormLiquidation.vue?vue&type=script&lang=js"
export * from "./FormLiquidation.vue?vue&type=script&lang=js"
import style0 from "./FormLiquidation.vue?vue&type=style&index=0&id=0c3eb0a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports